import AxiosInstance from "./api";

export const TrialBalanceService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/trial-balances/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/trial-balances/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/trial-balances", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/trial-balances/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/trial-balances/" + id);
  },
};
